import { Routes, Route } from 'react-router-dom';
import Navigation from '../src/Header/Navigation';
import InfoBanner from './Header/InfoBanner';
import Logo from './Header/Logo';
import './App.css';
import WeatherDetails from './Body/WeatherDetails';
import CurrencyExchange from './Body/CurrencyExchange';
import Profile from './Body/Profile';
import Cart from './Body/Cart';
import { useEffect } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

const App = () => {

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        const cleanedUser = {
          uid: firebaseUser.uid,
          displayName: firebaseUser.displayName,
          email: firebaseUser.email,
          photoURL: firebaseUser.photoURL,
        };
        localStorage.setItem("user", JSON.stringify(cleanedUser));
      } else {
        localStorage.removeItem("user");
      }
    });

    return () => unsubscribe();
  }, []);


  return (
    <div className="App">
      <InfoBanner />
      <Logo />
      <Navigation />

      <Routes>
        <Route path="/cart" element={<Cart />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/weather" element={<WeatherDetails />} />
        <Route path="/currency" element={<CurrencyExchange />} />
      </Routes>
    </div>
  );
};

export default App;
